'use client'

import {
  CheckboxGroupItem,
  CheckboxGroupRoot,
} from '@/components/ui/checkbox-group'
import { PRICE_FILTER } from '../constants'

type CheckboxItem = {
  value: string
  label: string
}

type Props = {
  onFilterChange: (value: string[]) => void
  items?: CheckboxItem[]
  value?: string[]
}

export const FilterPriceRange = ({ onFilterChange, items, value }: Props) => {
  // Default price filters if no items are provided

  const defaultItems: CheckboxItem[] = PRICE_FILTER

  // Use provided items or fall back to default price items
  const checkboxItems = items || defaultItems

  return (
    <CheckboxGroupRoot
      name='filter-checkbox-group'
      onValueChange={(values: string[]) => onFilterChange(values)}
      value={value}
    >
      {checkboxItems.map((item) => (
        <CheckboxGroupItem
          key={item.value}
          value={item.value}
          title={item.label}
        />
      ))}
    </CheckboxGroupRoot>
  )
}
